import React, { useEffect, useRef, useState, useContext } from "react";
import Chart from "chart.js/auto";
import schoolApi from "../../api/schoolApi";
import { SessionContext } from "../SessionProvider";


const FeesChart = () => {
  const { selectedSessionId, setSelectedSessionId } = useContext(SessionContext);

  const [feeData, setFeeData] = useState([]);
  const chartRef = useRef(null);

  useEffect(() => {
    const fetchFeeDeposit = async () => {
      try {
        // const sessions = await schoolApi.fetchSessions();
        // if (sessions.success) {
        //   const currentDate = new Date();
          // const fetchSelectedSessionResult = sessions?.result?.find((res) => {
          //   const startDate = new Date(res.startdate);
          //   const endDate = new Date(res.enddate);
          //   return currentDate >= startDate && currentDate <= endDate;
          // });

          const fetchDeposit = await schoolApi.fetchfeesChartdata(selectedSessionId);
         
          if (fetchDeposit.success && fetchDeposit.result) {
            setFeeData(fetchDeposit.result);
          } else {
            setFeeData([]);
            console.error("Invalid API response:", fetchDeposit);
          }
      //  } else {
        //  setFeeData([]);
        //}
      } catch (error) {
        setFeeData([]);
        console.error("Error fetching fee deposits", error);
      }
    };

    fetchFeeDeposit();
  }, [selectedSessionId]);

  useEffect(() => {
    if (chartRef.current) {
      const ctx = chartRef.current.getContext("2d");

      let data, options;

      if (feeData.length > 0) {
       

        const labels = feeData.map((item) => item.classname);
        const feedeposite = feeData.map((item) => {
         
          return item.total_deposite;
        });

        const totalAmount = feeData.map((item) => item.total_amount);

        const pendingFees = totalAmount.map(
          (total, index) => total - feedeposite[index]
        );

        data = {
          labels: labels,
          datasets: [
            {
              label: "Deposited Fees",
              backgroundColor: "rgba(75, 192, 192, 0.8)",
              data: feedeposite,
              stack: "combined",
            },
            {
              label: "Pending Fees",
              backgroundColor: "rgba(255, 99, 132, 0.8)",
              data: pendingFees,
              stack: "combined",
            },
          ],
        };
      } else {
       

        data = {
          labels: ["No Data"],
          datasets: [
            {
              label: "Deposited Fees",
              backgroundColor: "rgba(200, 200, 200, 0.8)",
              data: [0],
              stack: "combined",
            },
            {
              label: "Pending Fees",
              backgroundColor: "rgba(200, 200, 200, 0.5)",
              data: [0],
              stack: "combined",
            },
          ],
        };
      }

      options = {
        responsive: true,
        plugins: {
          legend: {
            position: "top",
          },
        },
        scales: {
          x: {
            stacked: true,
            title: {
              display: true,
              text: "Classes",
            },
          },
          y: {
            stacked: true,
            beginAtZero: true,
            title: {
              display: true,
              text: "Amount (in INR)",
            },
          },
        },
      };

      const myBarChart = new Chart(ctx, {
        type: "bar",
        data: data,
        options: options,
      });

      return () => {
        myBarChart.destroy();
      };
    }
  }, [feeData]);

  return (
    <div>
      <canvas id="myChart" ref={chartRef} width="400" height="400"></canvas>
    </div>
  );
};

export default FeesChart;
